import { CALLABO_API_BASE_URL } from '@/modules/Paths';
import { CallaboApiClient } from 'callabo-api/src/CallaboApiClient';
import { createContext } from 'react';

const callaboApiClient = new CallaboApiClient({
  BASE: CALLABO_API_BASE_URL,
});

export const ApiClientContext = createContext<CallaboApiClient>(callaboApiClient);
